import { Navigate } from 'react-router-dom'
import { useUser, useCan } from '../../hooks/useUser'
import { shouldShowOverview } from '../../lib/adminOverview'
import { adminNavItems } from '../../lib/adminNav'
import AdminOverview from './Overview'

/**
 * Landing component for `/admin`. Renders the aggregate Overview when it's worth
 * showing (admin, or ≥2 visible areas); otherwise sends a single-area grantee
 * straight to the one admin screen they can open, so they never land on a
 * near-empty Overview. RequirePermission("*") still guards the route itself.
 */
export default function AdminIndex() {
  const user = useUser()
  const can = useCan()

  if (shouldShowOverview(user.isAdmin, can)) {
    return <AdminOverview />
  }

  const firstTab = adminNavItems.find((item) => item.perm !== null && can(item.perm))
  if (firstTab) {
    return <Navigate to={firstTab.path} replace />
  }

  // No keyed screen available (shouldn't happen — RequirePermission("*") gates
  // the route on having at least one admin permission). Fall back to Overview.
  return <AdminOverview />
}
